import { render, staticRenderFns } from "./InformativeHighlights.vue?vue&type=template&id=54e56274&"
import script from "./InformativeHighlights.vue?vue&type=script&lang=js&"
export * from "./InformativeHighlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports